import * as React from 'react';

export default (props) => {
  const Class = `load__cont ` + (props.className ? props.className : '');
  return (
    <div className={Class}>
      <div className="load__logo">
        <img className="load__logo--m" src="/assets/img/logo-mark.svg" alt="" />
        <img className="load__logo--t" src="/assets/img/logo-text.svg" alt="" />
      </div>
    </div>
  )
};
